/** Returns the read-only status of the ontology */
export function isReadOnlyOntology(document?: Pick<EditModeDoc, 'readOnly' | 'type'>): boolean {
    return !!document && document.type === 'ONTOLOGY' && document.readOnly;
}
